var _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssuredpayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 169.839,
    height: 32,
    viewBox: "0 0 169.839 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16558"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 7040",
    d: "M16.723 0H150.2a12.542 12.542 0 0 1 12.542 12.542v2.787A12.542 12.542 0 0 1 150.2 27.871H11.148A11.148 11.148 0 0 1 0 16.723 16.723 16.723 0 0 1 16.723 0z",
    transform: "translate(7.096 1.908)",
    style: {
      fill: "#525252"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2592"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Flat Color"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49658",
    d: "M29.237 4.58a3.194 3.194 0 0 1 2.507 3.194v6.436A21.047 21.047 0 0 1 18.49 33.756a3.194 3.194 0 0 1-2.236 0A21.047 21.047 0 0 1 3 14.21v-6.5a3.194 3.194 0 0 1 2.507-3.194l11.179-2.475a2.858 2.858 0 0 1 1.373 0z",
    transform: "translate(-2.999 -1.958)",
    style: {
      fill: "#00e298"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Flat Color"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49658",
    d: "M22.8 3.937a2.41 2.41 0 0 1 1.892 2.41V11.2a15.884 15.884 0 0 1-10 14.751 2.41 2.41 0 0 1-1.687 0A15.884 15.884 0 0 1 3 11.2V6.3a2.41 2.41 0 0 1 1.892-2.41l8.436-1.868a2.157 2.157 0 0 1 1.036 0z",
    transform: "translate(.527 1.722)",
    style: {
      fill: "#11243e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49660",
    d: "M12.3 16.959a1.328 1.328 0 0 1-.929-.372l-3.024-2.974a1.329 1.329 0 0 1 1.872-1.885l2.1 2.058 5.457-5.311a1.333 1.333 0 1 1 1.872 1.9l-6.387 6.28a1.328 1.328 0 0 1-.956.305z",
    transform: "translate(1.002 2.939)",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2594"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Assured payment",
    transform: "translate(36.609 20.922)",
    style: {
      fontSize: 14,
      fontFamily: "Inter-SemiBold,Inter",
      fontWeight: 600,
      fill: "#fff"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Assured payment"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssuredpayments);
export default __webpack_public_path__ + "static/media/Assuredpayments.fb0cd9c9398dc87418135f3a4f674f42.svg";
export { ForwardRef as ReactComponent };